import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { SearchSearchViewFieldTypeSchema } from '@iconik-io/iconik-api/src/services/search';

import { initialSearchViewState } from './initial_state';

export const searchViewSlice = createSlice({
  name: 'search',
  initialState: initialSearchViewState,
  reducers: {
    setActiveSearchViewId: (state, action: PayloadAction<string>) => {
      state.activeViewId = action.payload;
    },
    clearActiveSearchViewId: (state) => {
      state.activeViewId = undefined;
    },
    setSearchDisplayFields: (
      state,
      action: PayloadAction<SearchSearchViewFieldTypeSchema[]>,
    ) => {
      state.currentDisplayFields = action.payload;
    },
  },
});

export const {
  setActiveSearchViewId,
  clearActiveSearchViewId,
  setSearchDisplayFields,
} = searchViewSlice.actions;

export const searchViewReducer = searchViewSlice.reducer;
